import { DialogKey } from '#src/components/navigation/WithDialogs/index.tsx';
import { ORIGIN } from '#src/config.ts';
import {
  ONBOARDING_MANGOPAY_KYC,
  WALLET,
} from '#src/constants/__generated__/routes.ts';
import { toInternalPath } from '#src/lib/urls.ts';

type LocationParts = { pathname: string; search: string };

export const JONUM_FLOW = 'jonum';

const getRedirectTarget = ({ pathname, search }: LocationParts) => {
  const params = new URLSearchParams(search);

  if (pathname === ONBOARDING_MANGOPAY_KYC) {
    return toInternalPath(params.get('redirectUrl'), WALLET);
  }

  params.delete('action');
  params.delete(DialogKey.jonumVerification);
  const remainingSearch = params.toString();

  return remainingSearch ? `${pathname}?${remainingSearch}` : pathname;
};

const getFlow = (
  flow: typeof JONUM_FLOW | undefined,
  { pathname, search }: LocationParts
) => {
  if (flow) {
    return flow;
  }

  if (pathname === ONBOARDING_MANGOPAY_KYC) {
    return new URLSearchParams(search).get('flow') === JONUM_FLOW
      ? JONUM_FLOW
      : null;
  }

  return null;
};

const buildReturnQuery = (
  location: LocationParts,
  flow?: typeof JONUM_FLOW
) => {
  const query = `redirectUrl=${encodeURIComponent(getRedirectTarget(location))}`;
  const resolvedFlow = getFlow(flow, location);

  return resolvedFlow
    ? `${query}&flow=${encodeURIComponent(resolvedFlow)}`
    : query;
};

export const buildReturnUrl = (
  location: LocationParts,
  flow?: typeof JONUM_FLOW
) => `${ORIGIN}${ONBOARDING_MANGOPAY_KYC}?${buildReturnQuery(location, flow)}`;

export const IFRAME_RETURN_URL = `${ORIGIN}/mangopay-kyc.html`;

const MOBILE_APP_RETURN_URL = `${ORIGIN}/mangopay-kyc-return.html`;

export const buildMobileAppReturnUrl = (
  location: LocationParts,
  flow?: typeof JONUM_FLOW
) => `${MOBILE_APP_RETURN_URL}?${buildReturnQuery(location, flow)}`;
